module.exports = __webpack_public_path__ + "img/gb_t6133_2_2006.prt.3a59d586.jpg";